// SwalUtils.js
import Swal from "sweetalert2";

// Function to confirm deletion
export const confirmDelete = (id) => {
  return Swal.fire({
    title: `Do you want to Remove ?`,
    text: "This action cannot be undone!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel"
  });
};

// Function to display success alert
export const showSuccessAlert = (id) => {
  Swal.fire({
    title: `Record Removed Successfully..!`,
    icon: "success",
    confirmButtonText: "OK"
  });
};
